export default __webpack_public_path__ + "static/media/cern-medium-italic.63a0eef3.woff2";